import { Button, Checkbox, DatePicker, Input, InputNumber } from 'antd'
import dayjs from 'dayjs'
import { STATUS_OPTIONS } from './constants'
import { DATE_API_FORMAT } from 'constants/dates'

interface FilterActionsProps {
  onReset: () => void
}

const FilterActions = ({ onReset }: FilterActionsProps) => (
  <div className="d-flex gap-2">
    <Button size="small" onClick={onReset}>Reset</Button>
  </div>
)

interface SearchFilterProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const SearchFilterDropdown = ({ value, onChange, placeholder }: SearchFilterProps) => (
  <div className="d-flex flex-column gap-2 p-2" onKeyDown={(e) => e.stopPropagation()}>
    <Input
      placeholder={placeholder}
      aria-label={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      allowClear
    />
    <FilterActions onReset={() => onChange('')} />
  </div>
)

interface NumberFilterProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  min?: number
}

export const NumberFilterDropdown = ({ value, onChange, placeholder, min }: NumberFilterProps) => (
  <div className="d-flex flex-column gap-2 p-2" onKeyDown={(e) => e.stopPropagation()}>
    <InputNumber
      placeholder={placeholder}
      aria-label={placeholder}
      value={value ? Number(value) : null}
      onChange={(v) => onChange(v != null ? String(v) : '')}
      min={min}
      className="w-100"
    />
    <FilterActions onReset={() => onChange('')} />
  </div>
)

interface DateRangeFilterProps {
  from?: string
  to?: string
  onChange: (from?: string, to?: string) => void
  placeholder?: [string, string]
}

export const DateRangeFilterDropdown = ({ from, to, onChange, placeholder }: DateRangeFilterProps) => (
  <div className="d-flex flex-column gap-2 p-2">
    <DatePicker.RangePicker
      value={from || to ? [from ? dayjs(from) : null, to ? dayjs(to) : null] : null}
      onChange={(dates) =>
        onChange(dates?.[0]?.format(DATE_API_FORMAT), dates?.[1]?.format(DATE_API_FORMAT))
      }
      format={DATE_API_FORMAT}
      placeholder={placeholder}
    />
    <FilterActions onReset={() => onChange()} />
  </div>
)

interface StatusFilterProps {
  value: string[]
  onChange: (value: string[]) => void
}

export const StatusFilterDropdown = ({ value, onChange }: StatusFilterProps) => (
  <div className="d-flex flex-column gap-2 p-2">
    <Checkbox.Group
      options={STATUS_OPTIONS}
      value={value}
      onChange={onChange}
      className="d-flex flex-column gap-1"
    />
    <FilterActions onReset={() => onChange([])} />
  </div>
)
